function Message($el) {
    this.$el = $el;
    this.$el.find(".message__close").click(this.close.bind(this));
    this.id = this.$el.data("messageId");
    this.geolocation = this.$el.data("messageGeolocation");
    this.messageCookie = new MessageCookie(this.id, this.$el.data("messageStart"), this.$el.data("messageEnd"), this.$el.data("messageExpiry"));
    if (!this.messageCookie.isValid()) {
        this._remove();
        return
    }
    if (this.geolocation) {
        messageGeolocation(this.geolocation).then(function(result) {
            if (result) {
                this.show()
            } else {
                this._remove()
            }
        }.bind(this)).catch(function(error) {
            this.show()
        }.bind(this))
    } else {
        this.show()
    }
}
Message.prototype = {
    close: function() {
        this.messageCookie.setCookie();
        this._remove();
        SetDesign.doAction("css-vars/refresh")
    },
    show: function() {
        this.$el.addClass("message--show")
    },
    _remove: function() {
        this.$el.remove();
        this.$el = false
    }
};

function MessageCookie(id, start, end, expiry) {
    this.id = id;
    this.start = this._getTime(start);
    this.end = this._getTime(end);
    this.expiry = parseInt(expiry);
    this.now = dayjs();
    if (this.expiry > 1) {
        this.expiry = dayjs().add(this.expiry, "s")
    }
    this.cookie = this.id;
    if (this._expiryMismatch()) {
        this.setCookie()
    }
}
MessageCookie.prototype = {
    _getTime: function(str) {
        if (str) {
            var time = dayjs(str);
            if (dayjs.isDayjs(time)) {
                return time
            }
        }
        return false
    },
    setCookie: function() {
        if (!this.expiry) {
            return
        }
        var isSession = !dayjs.isDayjs(this.expiry);
        var expiry = isSession ? false : {
            expires: this.expiry.toDate()
        };
        var value = isSession ? this.cookie : this.expiry.toISOString();
        Cookies.set(this.cookie, value, expiry)
    },
    isValid: function() {
        var valid = true;
        if (this.start && this.now.isBefore(this.start) || this.end && this.now.isAfter(this.end) || Cookies.get(this.cookie)) {
            valid = false
        }
        return valid
    },
    _expiryMismatch: function() {
        var cookie = Cookies.get(this.cookie);
        if (cookie && cookie !== this.cookie) {
            var expiry = dayjs(cookie);
            if (dayjs.isDayjs(expiry) && expiry.isAfter(this.expiry)) {
                return true
            }
        }
        return false
    }
};
SetDesign.GeolocationRegion = function() {
    var promise;
    var sitRegionKey = "sitRegion";
    return function() {
        if (promise) {
            return promise
        }
        var deferred = jQuery.Deferred();
        var data = {
            fields: "country_code2"
        };
        if (window.sit && window.sit.geoApi) {
            data.apiKey = window.sit.geoApi
        }
        var localData = localStorage.getItem(sitRegionKey);
        if (localData) {
            deferred.resolve(localData === "1" ? false : localData)
        } else {
            promise = deferred.promise();
            jQuery.get("https://api.ipgeolocation.io/ipgeo", data).done(function(apiData) {
                localStorage.setItem(sitRegionKey, apiData.country_code2 || "1");
                deferred.resolve(apiData.country_code2)
            }).fail(function() {
                localStorage.setItem(sitRegionKey, "1");
                deferred.resolve(false)
            }).always(function() {
                promise = null
            })
        }
        promise = deferred.promise();
        return promise
    }
}();

function messageGeolocation(rules) {
    var deferred = jQuery.Deferred();
    if (!rules) {
        deferred.resolve(true);
        return deferred.promise()
    }
    SetDesign.GeolocationRegion().then(function(region) {
        if (!region) {
            deferred.resolve(!rules.include);
            return
        }
        if (rules.include && rules.include.indexOf(region) === -1) {
            deferred.resolve(false)
        } else if (rules.exclude && rules.exclude.indexOf(region) !== -1) {
            deferred.resolve(false)
        } else {
            deferred.resolve(true)
        }
    }).fail(function(error) {
        deferred.reject(error)
    });
    return deferred.promise()
}

function MessageModal(data) {
    this.modalID = data.existing_id || data.id;
    this.$modal = jQuery("#" + this.modalID);
    this.trigger = data.trigger;
    this.triggerParams = data.trigger_params;
    this.geolocation = data.geolocation;
    this.showed = false;
    this.messageCookie = new MessageCookie(data.id, data.start, data.end, data.expiry);
    if (this.trigger === "exit") {
        SetDesign.addFilter("enableExitIntent", function() {
            return true
        })
    }
    if (this.messageCookie.isValid() && this.$modal.length) {
        if (this.geolocation) {
            messageGeolocation(this.geolocation).then(function(result) {
                if (result) {
                    this.show()
                } else {
                    this._remove()
                }
            }.bind(this)).catch(function(error) {
                this.show()
            }.bind(this))
        } else {
            this.show()
        }
    } else {
        if (data.type !== "existing") {
            this._remove()
        }
    }
}
MessageModal.prototype = {
    show: function() {
        var self = this;
        var delay = self.trigger === "time" ? self.triggerParams * 1e3 : 500;
        if (self.trigger === "scroll" && jQuery(document).height() > SetDesign.viewport.height()) {
            SetDesign.addAction("scroll", self._onScroll, 10, self)
        } else if (self.trigger === "exit") {
            SetDesign.addAction("exitIntent", self._show.bind(self))
        } else {
            setTimeout(self._show.bind(self), delay)
        }
    },
    _onScroll: function(e, scrollPos) {
        var self = this;
        var vh = SetDesign.viewport.height();
        var docHeight = jQuery(document).height();
        if (scrollPos.top / (docHeight - vh) * 100 >= self.triggerParams && !self.showed) {
            self.showed = true;
            setTimeout(function() {
                SetDesign.removeAction("scroll", self._onScroll, self);
                self._show()
            }, 0)
        }
    },
    _show: function() {
        var self = this;
        self.showed = true;
        SetDesign.doAction("showModal", self.$modal);
        self.$modal.one("click", function() {
            self.messageCookie.setCookie()
        })
    },
    _remove: function() {
        this.$modal.remove()
    }
};
SetDesign(SetDesign.INIT, function($, _, window, document) {
    var addFilter = SetDesign.addFilter;
    var $messages = $("[data-message-id]").filter(function(i, el) {
        var message = new Message($(el));
        return message.$el
    });
    if ($messages.length) {
        addFilter("stickyHeader/triggerHeight", function(val) {
            var height = $messages.first().height() || 0;
            height = height ? height + 20 : 0;
            return val + height
        }, 5);
        addFilter("css-vars/register", function(styles) {
            styles["navburger-top"] = function() {
                return "40px"
            };
            styles["message-banner-height"] = function() {
                var totalHeight = 0;
                $("body > .message--show").each(function(i, el) {
                    totalHeight += $(el).outerHeight(true)
                });
                return totalHeight + "px"
            };
            return styles
        }, 20)
    }
    if (window.messageModals && window.messageModals.length) {
        addFilter("modalLockScroll", function(lock, $modal) {
            return $modal.hasClass("modal--popup") ? false : lock
        });
        var modal_config_scripts = window.messageModals;
        modal_config_scripts.forEach(function(item, index) {
            new MessageModal(item)
        })
    }
}, 5);